import { jsx as l } from "react/jsx-runtime";
import { Select as s } from "antd";
import { memo as d, useMemo as c } from "react";
import { useLanguageResolver as n } from "@biron-data/react-contexts";
import { U as h, e as f } from "../../../../dummyModel-DGc8qBEQ.js";
const R = d(function({
  value: i,
  activated: a,
  onChange: m,
  configuration: e
}) {
  const r = n(), p = c(
    () => h.filter((t) => !e || e && !(Object.keys(e.disablingReasons).find((o) => o === "withMetricWithGrowthAsRatio") && t.value === f.RATIO)).map((t, o) => /* @__PURE__ */ l(s.Option, { value: t.value, children: r.get(t.label) }, o)),
    [e, r]
  );
  return /* @__PURE__ */ l(s, { style: { width: "100%" }, onChange: m, virtual: !1, dropdownMatchSelectWidth: !1, disabled: !a, value: i, children: p });
});
export {
  R as default
};
//# sourceMappingURL=TypeSelector.js.map
